import React from "react";
import MarketingLayout, { Seo, Reveal, PageHero, FinalCta } from "@/components/marketing/MarketingLayout";
import { INDUSTRIES } from "@/lib/marketingSite";

export default function IndustriesPage() {
  return (
    <MarketingLayout>
      <Seo title="Industries We Serve — Vozelto AI Marketing" path="/industries"
        description="Vozelto powers marketing for e-commerce, home services, restaurants, salons, gyms, creators and agencies — AI marketing tailored to how your business actually works." />
      <PageHero caps="Industries we serve" title={<>Built for the businesses<br /><span className="brand-text">that don't have time to market.</span></>}
        subtitle="Vozelto learns your industry's rhythms — seasons, holidays, buying patterns — and produces marketing that sounds like you, not like software." />

      <section className="max-w-6xl mx-auto px-5 pb-16">
        <div className="grid md:grid-cols-2 gap-5" data-testid="industries-grid">
          {INDUSTRIES.map((ind) => (
            <Reveal key={ind.slug}>
              <div data-testid={`industry-card-${ind.slug}`} className="card-matte p-6 h-full group transition-all duration-300 hover:-translate-y-1 hover:border-[#6B3DFF]/30 border border-transparent">
                <div className="h-11 w-11 rounded-xl bg-[#6B3DFF]/12 flex items-center justify-center mb-4 transition-all duration-300 group-hover:bg-[#6B3DFF]/25">
                  <ind.icon size={22} className="brand-text" weight="duotone" />
                </div>
                <h3 className="font-head font-semibold text-lg">{ind.name}</h3>
                <p className="mt-2 text-sm text-[#7a7a7a] italic">"{ind.pain}"</p>
                <p className="mt-3 text-sm text-[#b5b5b5] leading-relaxed">{ind.how}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
      <FinalCta title="Your Industry. Your Voice. Your AI Team." />
    </MarketingLayout>
  );
}
